import { type PropsWithChildren } from "react";

import { ScreenshotCapture } from "./ScreenshotCaptureContext";
import type { ScreenshotCaptureContext as ScreenshotCaptureContextProps } from "./types";

export const ScreenshotCaptureProvider = ({ children, ...props }: PropsWithChildren<ScreenshotCaptureContextProps>) => (
  <ScreenshotCapture.Provider value={props}>{children}</ScreenshotCapture.Provider>
);
